import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconVtiger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 76 75'
    {...props}
  >
    <path
      fill='url(#Icon_vtiger_svg__a)'
      d='M56.656 52.18c-2.392 0-4.528-.513-6.58-1.538-2.05-1.026-3.759-2.478-5.04-4.273-2.307 1.111-4.7 1.624-7.178 1.624-4.613 0-8.544-1.623-11.876-4.956-3.247-3.247-4.956-7.262-4.956-11.876 0-.599.085-1.197.171-1.795a8 8 0 0 1 4.101 2.564c.171 3.332 1.453 6.151 3.93 8.373s5.298 3.418 8.63 3.418 6.323-1.196 8.801-3.589c.598 2.307 1.88 4.101 3.674 5.64 1.88 1.452 4.016 2.22 6.409 2.22q4.358 0 7.433-3.075t3.076-7.434-3.076-7.433q-3.075-3.075-7.433-3.076-3.59 0-6.409 2.307c-.512-3.076-1.88-5.64-4.186-7.605S41.105 18.6 37.944 18.6c-1.965 0-3.76.427-5.469 1.282-1.708.854-3.16 2.05-4.357 3.503a15.8 15.8 0 0 0-3.845-1.794c1.538-2.222 3.503-4.016 5.896-5.212 2.392-1.282 5.04-1.88 7.775-1.88 3.161 0 6.066.854 8.715 2.478 2.649 1.623 4.7 3.845 6.067 6.494 1.367-.428 2.734-.599 4.101-.599 4.101 0 7.519 1.453 10.424 4.273 2.82 2.82 4.272 6.323 4.272 10.424s-1.452 7.519-4.272 10.424c-3.076 2.734-6.494 4.187-10.595 4.187'
    />
    <path
      fill='url(#Icon_vtiger_svg__b)'
      d='M30.596 28.606c2.307-1.111 4.7-1.624 7.177-1.624 4.614 0 8.545 1.624 11.877 4.956 3.247 3.247 4.956 7.263 4.956 11.877 0 .598-.086 1.196-.171 1.794a8 8 0 0 1-4.102-2.564c-.17-3.332-1.452-6.151-3.93-8.373s-5.298-3.418-8.63-3.418-6.323 1.196-8.8 3.589c-.599-2.307-1.88-4.101-3.675-5.64-1.88-1.452-4.015-2.22-6.408-2.22q-4.358 0-7.433 3.075T8.38 37.492t3.076 7.433Q14.532 48 18.89 48.001q3.589 0 6.408-2.307c.513 3.076 1.88 5.64 4.187 7.605q3.46 3.076 8.203 3.076c1.965 0 3.76-.428 5.468-1.282s3.162-2.05 4.358-3.503a15.8 15.8 0 0 0 3.845 1.794c-1.538 2.222-3.504 4.016-5.896 5.212-2.392 1.282-5.041 1.88-7.775 1.88-3.162 0-6.067-.854-8.716-2.478-2.648-1.623-4.699-3.845-6.066-6.493-1.367.427-2.734.598-4.101.598-4.102 0-7.52-1.453-10.424-4.273-2.906-2.82-4.273-6.322-4.273-10.424s1.453-7.519 4.273-10.424 6.322-4.272 10.424-4.272c2.392 0 4.528.513 6.579 1.538 2.136 1.196 3.845 2.563 5.212 4.358'
    />
    <defs>
      <linearGradient
        id='Icon_vtiger_svg__a'
        x1={22.94}
        x2={69.165}
        y1={24.154}
        y2={45.712}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.03} stopColor='#39B54A' />
        <stop offset={0.35} stopColor='#40B574' />
        <stop offset={1} stopColor='#1F8C54' />
      </linearGradient>
      <linearGradient
        id='Icon_vtiger_svg__b'
        x1={5.322}
        x2={53.127}
        y1={31.904}
        y2={49.3}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.03} stopColor='#0755D3' />
        <stop offset={1} stopColor='#337EFF' />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgIconVtiger;
